import { useCallback } from 'react';
import { useQueryClient, type QueryKey } from '@tanstack/react-query';

export function useRefreshData(key: QueryKey) {
  const client = useQueryClient();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(() => client.invalidateQueries(key), [client]);
}
